





































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { MatterWorkMatterDto } from '../../models/matter-work/MatterWorkMatterDto';
import { DxLoadPanel } from 'devextreme-vue';
import _ from 'lodash';
import { PhaseTotal } from '../../models/PhaseTotal';
import { AutoTextDataDto } from '../../models/auto-text/AutoTextDataDto';
import { PhaseTypeDto } from '../../models/PhaseTypeDto';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { FeeTypeNameEnum } from '../../models/Fees/FeeTypeEnum';
import { MatterOverage } from '../../models/MatterOverage';
import { FeeSheetTypeEnum } from '../../models/Fees/FeeSheetTypeEnum';
import { FeeSheetRuleDto } from '../../models/Fees/FeeSheetRuleDto';
import { MattersService } from '../../service/MattersService';
import { FeeSheetRuleService } from '../../service/FeeSheetRuleService';
import { OveragesTypeEnum } from '../../models/audit/OveragesTypeEnum';
import { FeeBudgetRuleDto } from '../../models/fee-budgets/FeeBudgetRuleDto';
import {PhaseTaskEnum} from '../../models/PhaseTaskEnum';
import { MatterBestRulesForOverageDto } from '@/models/matter/MatterBestRulesForOverageDto';

@Component({
  components: {
    DxScrollView,
    DxLoadPanel
  }
})
export default class MatterTotals extends Vue {
  @Prop()
  matter!: MatterWorkMatterDto;

  get matterId(): Guid {
    return this.matter.MatterId;
  }

  @Prop()
  phaseTypes!: PhaseTypeDto[];

  @Prop()
  feeSheetRules!: FeeSheetRuleDto[];

  @Prop()
  feeBudgetRules!: FeeBudgetRuleDto[];

  @Prop()
  latestBatchIds!: Guid[];

  get activeBatchIds(): Guid[] {
    return this.latestBatchIds;
  }

  @Watch("matter.MatterId")
  async onMatterChanged() {
    this.updateSummary();
  }
  position  = { at: 'center', of:'#overage-summary'}
  gettingOverageDetails: boolean = false;
  mattersService: MattersService;
  autoTextData: AutoTextDataDto[] = [];
  dateFilter: any = (this.$options.filters as any);
  matterBestRuleForOverage: MatterBestRulesForOverageDto[] = [];

  get matterFeeSheetRules(): FeeSheetRuleDto[] {
    return this.feeSheetRules.filter(
      r =>
        r.ClientId === this.matter.ClientId &&
        (r.Country == null || r.Country.CountryCode === this.matter.CountryCode)
    );
  }

  get matterFeeBudgetRules() {
    return this.feeBudgetRules.filter(r => r.MatterId === this.matterId);
  }

  constructor() {
    super();
    this.mattersService = new MattersService();
  }

  get phaseTotals(): PhaseTotal[] {
    let lineItems = this.matter.LineItems;
    let groupedItems = _.groupBy(lineItems, i => i.AssignedPhaseName);

    let phases = Object.keys(groupedItems);
    let matterServicesTotal: number = 0;
    let matterExpensesTotal: number = 0;
    let matterTranslationTotal: number = 0;

    let result: PhaseTotal[] = _.map(groupedItems, (group, key) => {
      let services = _.sumBy(
        _.filter(group, i => i.FeeType === FeeTypeNameEnum.Service),
        i => i.IsExempt ? 0 : i.LineItemTotal
      );
      let expenses = _.sumBy(
        _.filter(group, i => i.FeeType === FeeTypeNameEnum.Expense),
        i => i.IsExempt ? 0 : i.LineItemTotal
      );
      let translations = _.sumBy(
        _.filter(group, i => i.FeeType === FeeTypeNameEnum.Translation),
        i => i.IsExempt ? 0 : i.LineItemTotal
      );

      matterServicesTotal += services;
      matterExpensesTotal += expenses;
      matterTranslationTotal += translations;

      let phaseType = _.find(this.phaseTypes, i => key === i.PhaseName);

      return {
        Services: services,
        Expenses: expenses,
        Translations: translations,
        PhaseType: key == null || key === 'null' ? 'Unassigned' : key,
        Total: services + expenses + translations,
        RgbHex: phaseType ? phaseType.RgbHex : undefined,
        PhaseOrder: phaseType ? phaseType.PhaseOrder : undefined
      };
    });

    result.sort(function(total1, total2) {
      let order1 = total1.PhaseOrder ? total1.PhaseOrder : 0
      let order2 = total2.PhaseOrder ? total2.PhaseOrder : 0
      return order1 - order2;
    });

    let total: PhaseTotal = {
      RgbHex: undefined,
      Services: matterServicesTotal,
      Expenses: matterExpensesTotal,
      Translations: matterTranslationTotal,
      PhaseType: 'Matter Total',
      Total: matterServicesTotal + matterExpensesTotal + matterTranslationTotal,
      PhaseOrder: undefined 
    };

    result.push(total);
    result.unshift({
      Services: 'Services',
      Expenses: 'Expenses',
      Translations: 'Translations',
      PhaseType: '',
      Total: 'Total',
      RgbHex: undefined,
      PhaseOrder: undefined
    });
    return result;
  }

  overageRowDetailsWarningStyle(item: MatterOverage) {
    return {
      'background-color': item.OverageType === OveragesTypeEnum.HardOverage
        ? 'rgba(255, 0, 0, 0.7)'
        : 'rgba(255, 255, 0, 0.7)'
    };
  }

  checkIfIsInCurrentBatch(batchId: Guid){
    return this.activeBatchIds && this.activeBatchIds.some(b => b == batchId);
  }

  beforeDestroy(): void {
    this.$root.$off("process-auto-text-value", this.handleUserSettingChanged);
    this.$root.$off('updatenavmatters', this.updateSummary)
  }

  created() {    
    this.loadData();
  }

  async mounted(): Promise<void> {
    this.$root.$on("process-auto-text-value", this.handleUserSettingChanged);
    this.$root.$on('updatenavmatters', this.updateSummary)
  }

  updateSummary() {
    this.gettingOverageDetails = true;
    this.mattersService.getMatterBestRulesForOverage(this.matter.MatterId)
    .then(result => {
      this.matterBestRuleForOverage = result;
    })
    .finally(() => {
      this.gettingOverageDetails = false
    });
  }
  async loadData() {
    this.updateSummary()
  }

  get matterOverages(): MatterOverage[] {
    let lineItems = this.matter.LineItems.filter(i => i.FeeType === FeeTypeNameEnum.Service);
    let groupedByAgent = _.groupBy(lineItems, i => i.AgentName);

    let result = _.flatMap(groupedByAgent, (linesByAgent, agentName) => {
      let groupedByPhase = _.groupBy(linesByAgent, i => i.AssignedPhaseTypeId);

      return _.flatMap(groupedByPhase, (linesByPhase, phaseTypeId) => {
        let overages: MatterOverage[] = [];
        let phaseType = this.phaseTypes.filter(t => t.PhaseTypeId === parseInt(phaseTypeId))[0];
         let lineItemsPhase = phaseType != null ? 
                              (phaseType.IsBatched ?
                              linesByPhase.filter(i => this.activeBatchIds && this.activeBatchIds.includes(i.BatchId)) 
                              : linesByPhase) : [];

        if (phaseType != null && lineItemsPhase && lineItemsPhase.length > 0) {
          let phaseTypeId = phaseType.PhaseTypeId;
          let bestRule = this.matterBestRuleForOverage.find(m => m.AgentName == agentName && m.PhaseTypeId == phaseTypeId)

          if(bestRule) {
            let overage: MatterOverage = {
                AliasName: phaseType.PhaseName,
                RgbHex: phaseType.RgbHex,
                Total: bestRule.PhaseAgentTotal ? bestRule.PhaseAgentTotal : 0,
                RuleValue: bestRule.RuleType == FeeSheetTypeEnum.Cap ? 
                          (bestRule.CapAmount ? bestRule.CapAmount : 0) : 
                          (bestRule.TargetAmount ? bestRule.TargetAmount : 0),
                TargetOrCap: bestRule.RuleType,
                OverageType: bestRule.HardOrSoftOverage == 0 ? OveragesTypeEnum.SoftOverage : OveragesTypeEnum.HardOverage,
                AgentName: agentName,
                PhaseOrder: phaseType.PhaseOrder
            };

            if(bestRule.FeeSheetRuleId) {
              if (overages.filter(mo => mo.AliasName == phaseType.PhaseName).length != 0) {
                if (bestRule.RuleType == FeeSheetTypeEnum.Cap) {
                  overages = overages.filter(mo => mo.TargetOrCap != FeeSheetTypeEnum.Target && mo.AliasName != phaseType.PhaseName);
                  overages.push(overage);
                }
              } else {
                overages.push(overage);
              }
            }
            else{
              overages.push(overage);
            }
          }
        }
        return overages;
      });
    });

    return _.sortBy(result, o => o.PhaseOrder);
  }

  handleUserSettingChanged(done: any) {
    done(this.autoTextData);
  }
}
